
export const castSlownikiToTable = (data) => {
    return Object.entries(data|| []).map((e) => ({unit: e[0], label: e[1]['label']}))
}